<main class="flex justify-center items-center h-screen text-start">
    <div class="md:w-[35rem] w-[25rem] flex flex-col gap-4 border-[1.5px] border-gray-200 rounded-lg p-7">

      <div class="flex flex-col gap-5">
        <h2 class="text-base font-semibold text-[#4B4B4B]"> <span [routerLink]="['/login']" class="text-[#8A8AA3] text-base ms-0.5 me-2 cursor-pointer"> <i [routerLink]="['/']" class="bi text-[#8A8AA3] text-base cursor-pointer" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i> {{ 'auth.back' | translate }}  </span>{{ 'auth.reset_password_otp.title' | translate }}</h2>
        <p class="text-[0.87rem] text-[#4B4B4B] leading-7">{{ 'auth.reset_password_otp.description' | translate }}</p>
      </div>

        <form class="flex flex-col gap-2" (ngSubmit)="submit()">
            <div class="flex justify-center items-center gap-3" dir="ltr">

              <input
                #otpInput
                *ngFor="let _ of [0,1,2,3,4,5]; let i = index"
                type="text"
                maxlength="1"
                inputmode="numeric"
                (input)="onInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="onPaste($event)"
                class="w-12 h-12 border border-gray-300 rounded-lg text-center text-xl outline-none"
              />

            </div>

            <div class="text-sm text-center mt-2">
              <span class="text-gray-500 text-sm">{{ 'auth.reset_password_otp.no_code_question' | translate }}</span>
              <button type="button" class="text-primary font-medium ms-1 cursor-pointer" (click)="resendOtp()" [disabled]="loading || resetLoading">{{ 'auth.reset_password_otp.resend' | translate }}</button>
            </div>

            <button class="generic-submit-button flex justify-center items-center gap-2" type="submit" [disabled]="loading || resetLoading">
              <span *ngIf="loading" class="w-3 h-3 border border-t-0 border-white rounded-full animate-spin"></span>
              {{ 'auth.reset_password_otp.submit' | translate }}
            </button>
        </form>

    </div>
</main>
